import React, { useContext, useEffect } from 'react'
import { IonButton, IonContent, IonPage, useIonToast } from '@ionic/react'
import { CustomSpacer, DetailContent, FooterButtons, StyleIonHeader, TextStyle } from '../../../components'
import styled from 'styled-components'
import { DivideLineBold } from '../../../components/atoms/divide'
import { RouteComponentProps } from 'react-router'
import { StoresContext } from '../../../provider/StoreProvider'
import { observer } from 'mobx-react'
import { onCopyContent } from '../../../common'

export const AccountDeposit: React.FC<RouteComponentProps> = observer(({ history }) => {
  const { myStore } = useContext(StoresContext)
  const [presentToast] = useIonToast()
  const detailStore = myStore.depositAccountStore

  useEffect(() => {
    detailStore.load(undefined, true)
  }, [])

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'충전'} href={'/myPage/account'} />
      <IonContent>
        <DetailContent detailStore={detailStore}>
          <AccountContainer>
            <TextStyle type={'b_15'}>예치금 충전 계좌는 가상계좌입니다.</TextStyle>
            <AddressContainer>
              <TextStyle type={'b_15'}>{detailStore.content?.account ?? '-'}</TextStyle>
              <IonButton
                onClick={() => {
                  onCopyContent(presentToast, {
                    content: String(detailStore.content?.account),
                    successMsg: '가상 계좌 번호가 복사되었습니다!',
                    failureMsg: '가상 계좌 번호 복사에 실패했습니다.',
                  })
                }}
              >
                복사
              </IonButton>
            </AddressContainer>
            <div>
              <TextStyle type={'r_14'}>은행명</TextStyle>&nbsp;&nbsp;
              <TextStyle type={'b_14'}>우주은행</TextStyle>
            </div>
            <CustomSpacer spacing="16px" />
            <div>
              <TextStyle type={'r_14'}>예금주</TextStyle>&nbsp;&nbsp;
              <TextStyle type={'b_14'}>{detailStore.content?.bankOwner ?? '-'}</TextStyle>
            </div>
          </AccountContainer>
          <DivideLineBold />
          <InfoContainer>
            <TextStyle type={'sb_13'}>안내</TextStyle>
            <ul>
              <li>최소 충전 가능 금액은 10,000원입니다.</li>
              <li>예치금 출금 시 수수료는 1,000원이 부과됩니다.</li>
              <li>예치금 충전은 은행 정산 상태에 따라 최대 10분 정도 소요될 수 있습니다.</li>
            </ul>
          </InfoContainer>
        </DetailContent>
      </IonContent>
      <FooterButtons button={{ text: '확인', color: 'dark', onClick: () => history.goBack() }} />
    </IonPage>
  )
})

const AccountContainer = styled.section`
  padding: 24px 20px;
`

const AddressContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-height: 60px;
  margin: 16px 0;
  padding: 15.5px;
  border: solid 1px var(--ion-color-gray100);
  border-radius: 8px;
  ion-button {
    width: 40px;
    height: 29px;
    font-size: 11px;
    font-weight: 600;
    color: #ffffff;
  }
`

const InfoContainer = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  font-size: 1px;
  ul {
    padding-left: 20px;
    font-size: 13px;
    color: #888888;
    line-height: 21px;
    margin: 5px 0;
  }
`
